import { colors } from "../../styles/theme.js";
import { MdOutlineWarning } from "react-icons/md";

const styles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    color: colors.text,
  },
};

export const IpodWarning = ({ header, message }) => {
  return (
    <div style={styles.loadingContainer}>
      <MdOutlineWarning size={100} color={colors.black} />
      <div style={{ fontSize: 48, paddingBottom: 10 }}>{header}</div>
      <div style={{ fontSize: 36 }}>{message}</div>
    </div>
  );
};
